import type { SVGProps } from 'react';

/** Figma `avatar-profile.svg` — `tools/make-icon-components.py`가 만든다. 손으로 고치지 않는다. */
export const AvatarProfileIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Profile">
      <path
        id="Vector"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36 18C36 27.9411 27.9411 36 18 36C8.05887 36 0 27.9411 0 18C0 8.05887 8.05887 0 18 0C27.9411 0 36 8.05887 36 18ZM23.4 14.4C23.4 17.3823 20.9823 19.8 18 19.8C15.0177 19.8 12.6 17.3823 12.6 14.4C12.6 11.4177 15.0177 9 18 9C20.9823 9 23.4 11.4177 23.4 14.4ZM18 33.3C21.2113 33.3 24.1915 32.3107 26.6525 30.6202C27.7394 29.8735 28.2039 28.4512 27.572 27.2938C26.2619 24.8945 23.5624 23.4 17.9999 23.4C12.4374 23.4 9.73794 24.8944 8.42785 27.2937C7.79588 28.4511 8.26038 29.8734 9.34732 30.62C11.8083 32.3106 14.7886 33.3 18 33.3Z"
        fill="#DFE0E2"
      />
    </g>
  </svg>
);
